import { doc, getDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardTeacher from '../layout/DashboardTeacher';
import DashboardStudent from '../layout/DashboardStudent';
import DashboardAdmin from '../layout/DashboardAdmin';
import { useAuth } from '../service/AuthContext';
import { db } from '../service/Firebase-config';

export default function Main() {
  const navigate = useNavigate();
  const { role } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const { currentUser, setUserInfo } = useAuth();

  useEffect(() => {
    const checkRole = async(expectedRole, collection) => {
      const userDoc = await getDoc(doc(db, collection, currentUser.uid));
      const userData = userDoc.data();
      setUserInfo(userData);
      let isAuth = false;
      if (expectedRole === 'teacher') {
        if (userData.role === 'teacher' || userData.role === 'admin') {
          isAuth = true;
        }
      } else {
        if (userData.role === expectedRole) {
          isAuth = true;
        }
      }
      return userData && isAuth;
    };
    const checkUserRole = async () => {
      if (currentUser) {
        let roleValid = false;
        if (!role) {
          return navigate(`/login/student`);
        }
        switch (role) {
          case 'admin':
            roleValid = await checkRole('admin', 'teachers');
            break;
          case 'teacher':
            roleValid = await checkRole('teacher', 'teachers');
            break;
          case 'student':
            roleValid = await checkRole('student', 'students');
            break;
          default:
            roleValid = false;
        }

        if (roleValid) {
          setIsLoading(false);
        } else {
          navigate(`/login/${role}`);
        }
      } else {
        navigate(`/login/${role}`);
      }
    };

    checkUserRole();
  }, [role, currentUser, navigate, setUserInfo]);

  if (isLoading) {
    return <h1>Loading...</h1>;
  }

  switch (role) {
    case 'admin':
      return <DashboardAdmin />;
    case 'teacher':
      return <DashboardTeacher />;
    case 'student':
      return <DashboardStudent />;
    default:
      return <h1>Invalid Role</h1>;
  }
}
